import { render } from "./practice-correspondence.html?vue&type=template&id=d56e3980&scoped=true&ts=true&external"
import script from "./practice-correspondence.ts?vue&type=script&lang=ts&external"
export * from "./practice-correspondence.ts?vue&type=script&lang=ts&external"

import "./practice-correspondence.scss?vue&type=style&index=0&id=d56e3980&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56e3980"]])

export default __exports__